<template>
  <div>
    <div class="carregando-show" v-if="carregando">
      <Loading size="medium"></Loading>
    </div>
    <div class="erro-carregando" v-if="!carregando && erro">
      <ErroResultados></ErroResultados>
    </div>
    <template v-if="!carregando && !erro">
      <!-- Cabeçalho com nome do município -->
      <!-- <div class="municipio-header">
        <div class="centro">
          <div class="titulo-pagina">
            <div class="triangulo-play"></div>
            <h1><span>{{ enteFederativoNome || 'Legislação Municipal' }}</span></h1>
          </div>
        </div>
      </div> -->
      
      <!-- Documento da legislação -->
      <ExibirLei :legislacao="legislacao" />
      <DownloadPdf 
        :url="urlPdf" 
        :evento="'visualizacao_pdf_legislacao_municipal'" 
        :categoria="'download_pdf_legislacao_municipal'" 
        :label="labelLegislacao" 
      />
    </template>
  </div>
</template>

<script>
import slugify from "slugify";

import LegislacaoMunicipalApi from "../../../services/LegislacaoMunicipalApi";
import Loading from "../../../components/Loading";
import ErroResultados from "../../../components/ErroResultados";
import DownloadPdf from "../../../components/DownloadPdf";
import ExibirLei from "../../../components/pesquisa_legislacao/ExibirLei";
import titleLegislacao from "../../../helpers/legislacao/titleLegislacao";
import metaDados from "../../../helpers/metaDados";

const truncate = require("lodash.truncate");

export default {
  name: "PesquisaLegislacaoMunicipalShow",
  props: {
    slug: {
      type: String,
      required: true,
    },
    id: {
      type: [String, Number],
      required: true,
    },
    documentSlug: {
      type: String,
      required: false,
    },
  },
  metaInfo() {
    if (!this.legislacao) {
      return {};
    }

    let title = titleLegislacao(this.legislacao);
    const description = truncate(this.legislacao.ementa, {length: 160});

    return {
      title,
      titleTemplate: `%s - ${this.enteFederativoNome || 'Município'} - Casa Civil do Estado de Goiás`,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: description,
        },
        ...metaDados(this.legislacao),
      ],
    };
  },
  data() {
    return {
      legislacao: null,
      enteFederativo: null,
      enteFederativoNome: null,
      carregando: true,
      erro: false,
      urlPdf: null,
      labelLegislacao: null,
      legislacaoApi: null,
    };
  },
  components: {
    Loading,
    ErroResultados,
    DownloadPdf,
    ExibirLei,
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();
  },
  async mounted() {
    await this.obterEnteFederativo();
    await this.carregarLegislacao();
  },
  methods: {
    async obterEnteFederativo() {
      try {
        const allEntesFederativos = await this.legislacaoApi.getEntesFederativos();
        this.enteFederativo = allEntesFederativos.find(ente => ente.slug === this.slug);
        if (this.enteFederativo) {
          this.enteFederativoNome = this.enteFederativo.nome;
        }
      } catch (err) {
        console.error("Erro ao obter Ente Federativo: ", err);
      }
    },
    async carregarLegislacao() {
      try {
        this.carregando = true;
        this.erro = false;

        if (!this.enteFederativo || !this.enteFederativo.id) {
          console.error("ID do Ente Federativo não disponível para carregar legislação.");
          this.erro = true;
          this.carregando = false;
          return;
        }

        const legislacao = await this.legislacaoApi.getLegislacaoMunicipalById(
          this.enteFederativo.id,
          this.id
        );

        this.legislacao = legislacao;
        this.urlPdf = `${process.env.VUE_APP_BASE_API_URL}/api/v2/${this.slug}/pesquisa/legislacoes/${this.id}/pdf`;

        this.labelLegislacao = this.criarLabelLegislacao();

        const slug = this.createSlug();
        if (this.$route.params && this.$route.params.documentSlug != slug) {
          this.$router.replace({
            name: "PesquisaLegislacaoMunicipalShow",
            params: { 
              slug: this.slug,
              id: this.id,
              documentSlug: slug 
            },
            query: this.$route.query,
          });
        }

        this.carregando = false;
      } catch (err) {
        console.log("carregarLegislacao", err);
        this.carregando = false;
        this.erro = true;
      }
    },
    criarLabelLegislacao() {
      if (!this.legislacao) return "";

      const tipoLegislacao = this.legislacao.tipo_legislacao?.nome;
      if (tipoLegislacao && this.legislacao.numero) {
        return `${tipoLegislacao} Nº ${this.legislacao.numero} / ${this.legislacao.ano}`;
      }
      return "";
    },
    createSlug() {
      if (!this.legislacao) return "";

      const tipoLegislacao = this.legislacao.tipo_legislacao?.nome;
      if (tipoLegislacao) {
        const slug = `${tipoLegislacao} ${this.legislacao.numero.replace(/\./g, "")}`;
        return slugify(slug, {
          lower: true,
          strict: true,
          locale: "pt",
        });
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>

.carregando-show {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
}

.erro-carregando {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
}

.municipio-header {
  background-color: #f8f9fa;
  padding: 1rem 0;
  border-bottom: 2px solid #e9ecef;
}

.centro {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.titulo-pagina {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 0;
  flex-wrap: wrap;
}

.triangulo-play {
  width: 0;
  height: 0;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 25px solid darkgreen;
}

h1 span {
  background-color: #ffb24e;
  color: #115810;
  border-radius: 12px;
  padding: 0 0.3rem;
  margin: 0;
  display: inline;
  line-height: normal;
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
}

@media screen and (max-width: 480px) {
  .titulo-pagina {
    gap: 0.6rem;
  }
  .triangulo-play {
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 18px solid darkgreen;
  }
}

@media screen and (max-width: 1023px) {
  .titulo-pagina {
    margin-left: 1rem;
  }
}
</style>
